import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
//import { FlexModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { mdiAlertCircleOutline, mdiArrowLeft, mdiEmoticonSadOutline, mdiPlus } from "@mdi/js";

import { DffFormControlModule } from "@dffedb/forms";
import {
    AccordionStatusIndicatorModule,
    DffSideModule,
    DffUploadProgressOverlayModule,
    EmptyPageBadgeModule,
    PageErrorModule
} from "@dffedb/ui";
import { DffErrorPanelModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";
import { MaalerAflaesningModule, MaalerOprettelseModule } from "@e-forsyning/common/maaler";
import { NoteModule } from "@e-forsyning/common/note";

import { OpgaveListeComponent } from "./opgave-liste/opgave-liste.component";
import { ArbejdsgangComponent } from "./opgave/arbejdsgang/arbejdsgang.component";
import { BatteriskiftModule } from "./opgave/arbejdsgang/batteriskift/batteriskift.module";
import { EjendomsfaktorerModule } from "./opgave/arbejdsgang/ejendomsfaktorer/ejendomsfaktorer.module";
import { InstallationsoprettelseModule } from "./opgave/arbejdsgang/installationsoprettelse/installationsoprettelse.module";
import { KomponenterModule } from "./opgave/arbejdsgang/komponenter/komponenter.module";
import { MaalerskiftModule } from "./opgave/arbejdsgang/maalerskift/maalerskift.module";
import { OpgaveNoteModule } from "./opgave/arbejdsgang/noter/opgave-note.module";
import { SendMailTilForbrugerModule } from "./opgave/arbejdsgang/send-mail-til-forbruger/send-mail-til-forbruger.module";
// eslint-disable-next-line max-len
import { ServicerapportAccordionPanelModule } from "./opgave/arbejdsgang/shared/servicerapport-accordion-panel/servicerapport-accordion-panel.module";
import { OpgaveComponent } from "./opgave/opgave.component";
import { OpgavestyringRoutingModule } from "./opgavestyring-routing.module";
import { ServicerapportMaalerOplysningerModule } from "./shared/servicerapport-maaler-oplysninger/servicerapport-maaler-oplysninger.module";

@NgModule({
    imports: [
        OpgavestyringRoutingModule,
        AccordionStatusIndicatorModule,
        CommonModule,
        DffErrorPanelModule,
        DffFormControlModule,
        DffSideModule,
        DffUploadProgressOverlayModule,
        EjendomsfaktorerModule,
        EmptyPageBadgeModule,
        FormsModule,
        InstallationsoprettelseModule,
        KomponenterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatListModule,
        MatProgressSpinnerModule,
        MaalerAflaesningModule,
        MaalerOprettelseModule,
        MaalerskiftModule,
        BatteriskiftModule,
        NoteModule,
        OpgaveNoteModule,
        PageErrorModule,
        ReactiveFormsModule,
        SendMailTilForbrugerModule,
        ServicerapportAccordionPanelModule,
        ServicerapportMaalerOplysningerModule
    ],
    exports: [OpgaveComponent, OpgaveListeComponent],
    declarations: [ArbejdsgangComponent, OpgaveComponent, OpgaveListeComponent],
    providers: []
})
export class EForsyningFeaturesOpgavestyringModule {
    constructor(svgIconRegistry: SvgIconRegistry) {
        svgIconRegistry.registerIcon(mdiArrowLeft, "arrow-left");
        svgIconRegistry.registerIcon(mdiPlus, "plus");
        svgIconRegistry.registerIcon(mdiAlertCircleOutline, "alert-circle-outline");
        svgIconRegistry.registerIcon(mdiEmoticonSadOutline, "emoticon-sad-outline");
    }
}
